import React, { useState, useEffect } from "react";
import { all_routes } from "../../../feature-module/router/all_routes";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { role } from "../../constants/userConstants";
import { useTranslation } from "react-i18next";

interface BreadcrumbProps {
  title: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ title }) => {
  const { moodleUser } = useAuth();
  const { t } = useTranslation();

  return (
    <>
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb d-flex justify-content-start align-items-center mb-2">
          <li className="breadcrumb-item">
            <Link
              to={
                moodleUser?.role?.roleid === role.student
                  ? all_routes.studentDashboard
                  : all_routes.instructorDashboard
              }
            >
              {t("sidebarMenu.home")}
            </Link>
          </li>
          {title.toLowerCase() !== "home" && (
            <li className="breadcrumb-item active" aria-current="page">
              {title}
            </li>
          )}
        </ol>
      </nav>
      {/* /Breadcrumb */}
    </>
  );
};

export default Breadcrumb;
